import {Component} from '@angular/core';

@Component({
    selector: 'app-export-xml-modal',
    templateUrl: './export-xml-modal.component.html',
})
export class ExportXmlModalComponent {
}
